import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-6caa3860"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "overview" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { style: {"font-size":"18px"} }, "Overview")
], -1))
const _hoisted_4 = { style: {"margin-top":"16px"} }
const _hoisted_5 = { class: "condition-title" }
const _hoisted_6 = { style: {"padding-left":"16px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, "Year", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, "Payout round", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, "Payout Status", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"23px"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_12 = { style: {"margin-right":"16px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Download Payout Files")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Withdraw")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Submit For Mgmt. Approve")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_17 = {
  style: {"margin":"4px"},
  class: "payment-table-column-wrapper"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Attachment")
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Approve Path")
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "pagination-container d-f justify-e" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Delete confirmation", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Delete the current data?", -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Confirm")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Withdraw confirmation", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Confirm")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Submit confirmation", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Submit for Approval?", -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_ApproveSteps = _resolveComponent("ApproveSteps")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_upload_detail = _resolveComponent("upload-detail")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ApproveSteps, {
        visible: _ctx.approveVisible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.approveVisible) = $event)),
        data: _ctx.approveList
      }, null, 8, ["visible", "data"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["condition", { 'open-condition': _ctx.isOpen }])
          }, [
            _createElementVNode("section", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_space, { style: {"display":"flex","justify-content":"space-between"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        style: {"margin-right":"8px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                value: _ctx.year,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.year) = $event)),
                                style: {"width":"120px","height":"30px"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initSelectedDataForS.year, (yr) => {
                                    return (_openBlock(), _createBlock(_component_a_select_option, { key: yr }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(yr), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        style: {"margin-right":"8px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createVNode(_component_a_select, {
                            value: _ctx.payoutRound,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payoutRound) = $event)),
                            style: {"min-width":"120px","height":"30px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initSelectedDataForS.payoutRound, (payoutRound) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: payoutRound }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(payoutRound), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, {
                        direction: "vertical",
                        style: {"margin-right":"8px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createVNode(_component_a_select, {
                            value: _ctx.status,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.status) = $event)),
                            style: {"width":"120px","height":"30px"},
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initSelectedDataForS.status, (stus) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: stus.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(stus.value), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              (_ctx.$btnPermissions('F&L PM-RT0001'))
                                ? (_openBlock(), _createBlock(_component_a_button, {
                                    key: 0,
                                    type: "primary",
                                    style: {"margin-right":"8px"},
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.mulSearchEvent(_ctx.rowSelection)), ["stop"]))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.$btnPermissions('F&L PM-RT0002'))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                      title: _withCtx(() => [
                        _hoisted_13
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "font_family icon-xiazai",
                          style: {"font-size":"24px"},
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.downloadFilesClick && _ctx.downloadFilesClick(...args)))
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('F&L PM-RT0003'))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 1 }, {
                      title: _withCtx(() => [
                        _hoisted_14
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "font_family icon-fanhui m-l-12",
                          style: {"font-size":"24px"},
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onWithdraw && _ctx.onWithdraw(...args)))
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('F&L PM-RT0004'))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 2 }, {
                      title: _withCtx(() => [
                        _hoisted_15
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "font_family icon-SubmitforMgmtApprove m-l-12",
                          style: {"font-size":"24px"},
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('F&L PM-RT0005'))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 3 }, {
                      title: _withCtx(() => [
                        _hoisted_16
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "font_family icon-shanchu m-l-12",
                          style: {"font-size":"24px"},
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_a_table, {
          "row-selection": _ctx.rowSelection,
          columns: _ctx.columns,
          scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight},
          pagination: false,
          dataSource: _ctx.tableData,
          rowKey: "id",
          rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
        }, {
          action: _withCtx(({ record }) => [
            (_ctx.$btnPermissions('F&L PM-RT0006'))
              ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                  title: _withCtx(() => [
                    _hoisted_18
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "font_family icon-Attachment",
                      style: {"font-size":"24px"},
                      onClick: ($event: any) => (_ctx.uploadHandle(record))
                    }, null, 8, _hoisted_19)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (_ctx.$btnPermissions('F&L PM-RT0012'))
              ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 1 }, {
                  title: _withCtx(() => [
                    _hoisted_20
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "font_family icon-ApprovalPath m-l-20",
                      style: {"font-size":"24px"},
                      onClick: ($event: any) => (_ctx.approveClick(record))
                    }, null, 8, _hoisted_21)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["row-selection", "columns", "scroll", "dataSource", "rowClassName"])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_a_pagination, {
        total: _ctx.total,
        "show-size-changer": "",
        "show-total": (total) => `共 ${total} 条`,
        onChange: _ctx.handlePageChange,
        onShowSizeChange: _ctx.handleSizeChange,
        pageSize: _ctx.pageSize,
        "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pageSize) = $event)),
        current: _ctx.pageNumber,
        "onUpdate:current": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pageNumber) = $event)),
        pageSizeOptions: ['10', '20', '30', '40', '50']
      }, {
        buildOptionText: _withCtx((props) => [
          _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
        ]),
        _: 1
      }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "pageSize", "current"])
    ]),
    (_ctx.isUploadVisible)
      ? (_openBlock(), _createBlock(_component_upload_detail, {
          key: 0,
          onListChange: _ctx.uploadHandle,
          isUploadVisible: _ctx.isUploadVisible,
          paymentId: _ctx.paymentId,
          payoutCode: _ctx.code,
          payoutRound: _ctx.round,
          payStatus: _ctx.statusToUpload,
          attachmentData: _ctx.attachmentData,
          onCloseUploadVisible: _ctx.closeUpload
        }, null, 8, ["onListChange", "isUploadVisible", "paymentId", "payoutCode", "payoutRound", "payStatus", "attachmentData", "onCloseUploadVisible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.deleteModalVisible,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.deleteModalVisible) = $event)),
      width: 400,
      class: "batch-query-modal",
      centered: ""
    }, {
      title: _withCtx(() => [
        _hoisted_23
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deleteModalVisible=false))
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _ctx.onDeleteConfirm,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_24
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.withdrawModalVisible,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.withdrawModalVisible) = $event)),
      width: 400,
      class: "batch-query-modal",
      centered: ""
    }, {
      title: _withCtx(() => [
        _hoisted_27
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.withdrawModalVisible=false))
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _ctx.onWithdrawConfirm,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_textarea, {
            value: _ctx.withdrawInstructions,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.withdrawInstructions) = $event)),
            placeholder: "Withdraw the instructions",
            rows: 4
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.submitModalVisible,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.submitModalVisible) = $event)),
      width: 400,
      class: "batch-query-modal",
      centered: ""
    }, {
      title: _withCtx(() => [
        _hoisted_30
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.submitModalVisible=false))
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _ctx.onSubmitConfirm,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_31
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}